<div >
    <button mat-icon-button [matMenuTriggerFor]="menu" (click)="show($event)">
        <img src={{iconPath}}>
      </button>
      <mat-menu #menu="matMenu"  class="background-notification">
          <mat-card *ngFor="let notification of notifications; let i = index" class="card-notification">
              <div class="close">
                <p><strong (click)="closeNotification(i)">x</strong></p>
            </div>
            <div>
                <p>{{notification}}</p>
            </div>
        </mat-card>
    </mat-menu>
</div>